import { createFileRoute } from "@tanstack/react-router";
import AdminRoadmap from "@/pages/admin/AdminRoadmap";

export const Route = createFileRoute("/admin/roadmap")({ component: AdminRoadmap });
